import React from "react";

import logo from "assets/cloud21/logo-min-sidebar.png";
import logo_sidebar from "static/cloud21/sidebar/logo-sidebar.png";
import Drawer from "shared/template/sideBar/SideBarFunctions";
import SidebarItems from "./SideBarItems";

interface SideBarProps {
    isSideBarAberto: boolean;
}

const SideBar: React.FC<SideBarProps> = (props) => {
    const isSideBarAberto = props.isSideBarAberto;

    return (
        <Drawer variant="permanent" className="menu" open={isSideBarAberto}>
            <div
                className={`${isSideBarAberto ? "imagem-header-aberto" : ""}`}
            >
                {!isSideBarAberto ? (
                    <img
                        src={logo}
                        alt="logo Group"
                        className={"imagem-header-fechado"}
                    />
                ) : (
                    <img src={logo_sidebar} alt="logo Group" />
                )}
            </div>

            <SidebarItems isSideBarAberto={isSideBarAberto} />
        </Drawer>
    );
};

export default SideBar;
